import React from 'react';
import { ForecastCardTitleDay } from '../../common/forecastCardTitleDay';
import { ForecastCardTitleHour } from '../../common/forecastCardTitleHour';
import { IForecastCard } from '../../common/types';
import { LargeCardTitleContainer } from '../../styles';

type LargeForecastCardTitleProps = Pick<IForecastCard, 'day' | 'hour'>;

export const LargeForecastCardTitle = ({ hour, day }: LargeForecastCardTitleProps) => {
    return (
        <LargeCardTitleContainer>
            <ForecastCardTitleHour hour={hour} />
            <ForecastCardTitleDay day={day} />
        </LargeCardTitleContainer>
    );
};